import React from 'react';
import { ArrowUpRight } from 'lucide-react';

// Importing unique project images from assets
import project1 from '../../assets/img/projects/project1.jpg';
import project2 from '../../assets/img/projects/project2.jpg';
import project3 from '../../assets/img/projects/project3.jpg';

const ProjectsSection = () => {
  const projectsList = [
    {
      id: 1,
      title: "BIM Modeling",
      img: project1
    },
    {
      id: 2,
      title: "Scan to BIM Modeling",
      img: project2
    },
    {
      id: 3,
      title: "3D Revit Model",
      img: project3
    }
  ];

  return (
    <section className="projects-section">
      <div className="projects-header">
        <h2 className="projects-title">
          <span className="text-primary">Our Latest</span> Projects
        </h2>

        <button className="projects-view-all desktop-only-btn">
          View All Projects <ArrowUpRight size={18} />
        </button>
      </div>

      <div className="projects-grid">
        {projectsList.map((project) => (
          <div key={project.id} className="project-card">
            <div
              className="project-card-img"
              style={{ backgroundImage: `url(${project.img.src || project.img})` }}
            >
              <div className="project-card-footer">
                {project.title}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="projects-section-footer mobile-only-btn-wrapper">
        <button className="projects-view-all">
          View All Projects <ArrowUpRight size={18} />
        </button>
      </div>
    </section>
  );
};

export default ProjectsSection;
